import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { isTrainer, isGolfer } from './role.utils';

/**
 * Route guard that ensures only trainers can access trainer routes.
 * Redirects golfers to /training and unauthenticated users to /signin.
 * 
 * Production-ready with proper error handling and type safety.
 */
export const trainerGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  
  try {
    // Check authentication token
    const token = localStorage.getItem('token');
    if (!token) {
      router.navigate(['/signin'], { replaceUrl: true });
      return false;
    }

    // Get user from auth service
    const user = authService.getUser();
    if (!user) {
      router.navigate(['/signin'], { replaceUrl: true });
      return false;
    }

    // Redirect golfers to their module
    if (isGolfer(user)) {
      router.navigate(['/training'], { replaceUrl: true });
      return false;
    }

    // Allow access only if user is a trainer
    if (isTrainer(user)) {
      return true;
    }

    // If role cannot be determined, redirect to signin
    router.navigate(['/signin'], { replaceUrl: true });
    return false;
  } catch (error) {
    // Handle any unexpected errors gracefully
    console.error('Error in trainerGuard:', error);
    router.navigate(['/signin'], { replaceUrl: true });
    return false;
  }
};

